import { useScript } from '#nuxt-scripts/composables/useScript'
import { defineNuxtPlugin } from 'nuxt/app'
import { useScriptGoogleTagManager } from '/builds/poo/webshop/frontend/node_modules/@nuxt/scripts/dist/runtime/registry/google-tag-manager.js'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const googleTagManager = useScriptGoogleTagManager({"id":"GTM-MTX59M24","debug":false,"scriptInput":{"src":"https://sst.woonboulevardpoortvliet.nl/gtm.js?id=GTM-MTX59M24","crossorigin":false}})
    return { provide: { $scripts: { googleTagManager } } }
  }
})